import { Menu, MenuItem } from '@material-ui/core';
import React, { useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

import { track } from '~/src/dash/analytics/analytics';
import { CaretDownIcon } from '~/src/dash/components/icons/misc-icons';
import { Col, Cols, spacing, Text, usePublicaTranslation } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { useBaseStore } from '~/src/dash/views/base/contexts';
import { useDashboardsStore } from '~/src/dash/views/dashboards/contexts';
import {
  EDashboardSection,
  findDashboardSectionByValue,
} from '~/src/dash/views/dashboards/DashboardHome/configs/dashboardsConfig';

export const DashboardSelector = () => {
  const { session, user, isSuperUser } = useBaseStore();
  const { t } = usePublicaTranslation();
  const { isPublica, isParentPublisher } = useDashboardsStore();
  const { activeSection, setActiveSection, sections } = useDashboardsStore();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);
  const [isHovered, setIsHovered] = useState(false);

  const currentSection = findDashboardSectionByValue(activeSection);
  if (currentSection.isPublicaOnly && session.publisher.ID !== '1') {
    setActiveSection(EDashboardSection.Overview);
  }

  const onMenuClick = ({ currentTarget }: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(currentTarget);
    track('Dash - Open Dash Selector', { isSuperUser }, user.user);
  };

  const onMenuClose = (section: number) => {
    unstable_batchedUpdates(() => {
      setActiveSection(section);
      setAnchorEl(undefined);
    });
  };

  return (
    <>
      <div
        onClick={onMenuClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          display: 'inline-block',
          padding: `0 ${spacing.base}`,
          margin: 0,
          whiteSpace: 'nowrap',
          textTransform: 'capitalize',
          cursor: 'pointer',
          borderRadius: '6px',
          backgroundColor: isHovered ? publicaColors.veryLightGray : 'inherit',
        }}
      >
        <Cols gap={spacing.base} style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Col flex>
            <Text extraLarge bold disableSelect inlineBlock cypressID='current_dashboard_label'>
              {/* eslint-disable-next-line @typescript-eslint/no-unsafe-call */}
              {currentSection.tKey ? t(currentSection.tKey) : currentSection.label}
            </Text>
          </Col>
          <Col displayFlex>
            <CaretDownIcon color={publicaColors.veryDarkGray} />
          </Col>
        </Cols>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(undefined)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          style: {
            transform: 'translateX(5%) translateY(0%)',
            width: '192px',
          },
        }}
      >
        {sections.map((section) => {
          if (section.isParentPublisherOnly && !isParentPublisher) return;
          if (section.isPublicaOnly && !isPublica) return;
          return (
            <MenuItem onClick={() => onMenuClose(section.value)}>
              {/* eslint-disable-next-line @typescript-eslint/no-unsafe-call */}
              {section.tKey ? t(section.tKey) : section.label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
